import React from 'react';

interface DeleteGalleryModalProps {
  show: boolean;
  imageTitle: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteGalleryModal: React.FC<DeleteGalleryModalProps> = ({ show, imageTitle, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onCancel} style={{ zIndex: 1040 }}></div>
      <div
        className={`modal fade ${show ? 'show' : ''}`}
        style={{ 
          display: show ? 'block' : 'none',
          zIndex: 1050,
          paddingRight: show ? '17px' : '0'
        }}
        tabIndex={-1}
        aria-labelledby="deleteGalleryModalLabel"
        aria-hidden={!show}
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onCancel();
          }
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" style={{ margin: '1rem' }}>
          <div className="modal-content card-surface" style={{ zIndex: 1051, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <div className="modal-header border-bottom pb-3 flex-shrink-0">
              <h5 className="modal-title fw-bold h5 mb-0 d-flex align-items-center gap-2" id="deleteGalleryModalLabel" style={{ fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
                <i className="bi bi-exclamation-triangle text-danger" style={{ fontSize: 'clamp(1.25rem, 4vw, 1.5rem)' }}></i>
                Delete Gallery Image
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                aria-label="Close"
                style={{ minWidth: '44px', minHeight: '44px' }}
              ></button>
            </div>
            <div className="modal-body p-3 p-md-4 flex-grow-1 overflow-auto">
              <p className="mb-0 text-white" style={{ fontSize: 'clamp(0.9rem, 2.5vw, 1rem)', lineHeight: '1.6' }}>
                Do you want to delete this gallery image <strong className="text-danger">"{imageTitle}"</strong>?
              </p>
              <p className="mt-3 mb-0 text-muted-soft small" style={{ fontSize: 'clamp(0.8rem, 2vw, 0.875rem)' }}>
                This action cannot be undone. The image will be permanently removed from the gallery.
              </p>
            </div>
            <div className="modal-footer border-top d-flex flex-column flex-sm-row gap-2 flex-shrink-0 p-3 p-md-4">
              <button 
                type="button" 
                className="btn btn-outline-secondary flex-fill w-100 w-sm-auto" 
                onClick={onCancel}
              >
                Cancel
              </button>
              <button 
                type="button" 
                className="btn btn-danger flex-fill w-100 w-sm-auto" 
                onClick={onConfirm}
              >
                <i className="bi bi-trash me-1"></i>
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteGalleryModal;
